import { quoteTypeToTracking } from 'models';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { RequestType } from 'models/productsReferential';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { dynamicQuoteRequestedThunk } from 'state/dynamic/dynamicForm.thunks';
import { getQuoteTypeByAvailableActions } from 'state/selectors/common';
import type { Thunk } from 'state/state.common';

import { workspaceTabPersistRequested, workspaceTabProductSelectionSubmitted } from '../workspace.actions';
import { dynamicWorkspaceTabSetQuote, dynamicWorkspaceTabUnsetQuote } from './dynamic.actions';
import { getWorkspaceDynamicTabQuoteId } from './dynamic.selectors';

export function dynamicTabSetAssociatedQuoteThunk(tabId: string, quoteId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const oldQuoteId = getWorkspaceDynamicTabQuoteId(state, tabId);
    if (quoteId !== oldQuoteId) {
      dispatch(dynamicWorkspaceTabSetQuote(tabId, quoteId));
      dispatch(workspaceTabPersistRequested(tabId, 'dynamic'));
    }
  };
}

export function dynamicTabResetAssociatedQuoteThunk(tabId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const oldQuoteId = getWorkspaceDynamicTabQuoteId(state, tabId);
    if (oldQuoteId !== undefined) {
      dispatch(dynamicWorkspaceTabUnsetQuote(tabId));
      dispatch(workspaceTabPersistRequested(tabId, 'dynamic'));
    }
  };
}

export function dynamicWorkspaceTabProductSelectionSubmittedThunk(
  tabId: string,
  productType: string,
  productSubType: string,
  wrapper: string,
  requestType: RequestType | undefined,
  client: Nullable<ISalesCounterpart>,
): Thunk<void> {
  return dispatch => {
    dispatch(
      workspaceTabProductSelectionSubmitted(
        tabId,
        {
          productType,
          productSubType,
          wrapper,
          requestType,
        },
        client,
        'dynamic',
      ),
    );
  };
}

export function dynamicWorkspaceRepriceQuoteThunk(tabId: string): Thunk<void> {
  return (dispatch, getState, { selectors: { getDynamicFormQuoteId } }) => {
    const state = getState();
    const quoteId = getDynamicFormQuoteId(state, tabId)!;
    const quoteType = getQuoteTypeByAvailableActions(state, 'dynamic', tabId);
    if (quoteType) {
      logAnalytics.trackEvent('Primary market dynamic', quoteTypeToTracking[quoteType]);
    }
    dispatch(dynamicQuoteRequestedThunk(tabId, quoteType!, quoteId));
  };
}
